import { GifsResult } from '@giphy/js-fetch-api'
import { createContext, ReactNode, useState } from 'react'
import UgeEditor from '../types/editor'

type EditorProps = {
    layerId?: string
    searchTerm?: string
}

type ContextProps = {
    activeEditor: UgeEditor
    activeEditorProps?: EditorProps
    apiKey: string
    fetchFavorites?: (offset: number) => Promise<GifsResult>
    openEditor: (editor: UgeEditor, props?: EditorProps) => void
    resetEditorProps: () => void
}

type Props = {
    apiKey: string
    children?: ReactNode
    fetchFavorites?: (offset: number) => Promise<GifsResult>
}

export const UgeEditorContext = createContext({} as ContextProps)

const UgeEditorContextManager = ({ apiKey, children, fetchFavorites }: Props) => {
    const [activeEditor, setActiveEditor] = useState<UgeEditor>('default')
    const [activeEditorProps, setActiveEditorProps] = useState<EditorProps | undefined>()

    const openEditor = (editor: UgeEditor, props?: EditorProps) => {
        setActiveEditorProps(props)
        setActiveEditor(editor)
    }

    const resetEditorProps = () => {
        setActiveEditorProps(undefined)
    }

    return (
        <UgeEditorContext.Provider
            value={{ activeEditor, activeEditorProps, apiKey, fetchFavorites, openEditor, resetEditorProps }}
        >
            {children}
        </UgeEditorContext.Provider>
    )
}

export default UgeEditorContextManager
